import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const REGISTER_URL = "https://bid.ballypatrickauctions.com/register";

export const api = axios.create({ baseURL: API, withCredentials: true });
